<!-- 

            // painel: [
            //     { 
            //         codetapa: '1',
            //         descricao: 'Lead',
            //         totais: [
            //             { moeda: 'R$', total: 2500 },
            //         ],
            //         negocios: [
            //             { 
            //                 codnegocio: 1, 
            //                 titulo: 'Negocio Fornoflex', 
            //                 valor: 500, 
            //                 dataprevista: '2020-03-15', 
            //                 org_nome: 'FORNOFLEX', 
            //                 pessoa_nome: 'EBOROMELLO', 
            //                 count_agenda: 2,
            //                 negocio_atraso: true, 
            //                 stnegocio: 'G',
            //             },
            //             { 
            //                 codnegocio: 2, 
            //                 titulo: 'Negocio Cozilandia', 
            //                 valor: 1500, 
            //                 dataprevista: '2020-03-31', 
            //                 org_nome: 'COZILANDIA', 
            //                 pessoa_nome: 'EBOROMELLO', 
            //                 count_agenda: 2,
            //                 negocio_atraso: true, 
            //                 stnegocio: 'A',
            //             },
            //         ]
            //     },

            //     { 
            //         codetapa: '2',
            //         descricao: 'Contatado',
            //         totais: [
            //             { moeda: 'R$', total: 2500, count_negocios: 3 },
            //         ],
            //         negocios: [
            //             {
            //                 codnegocio: 1, 
            //                 titulo: 'Negocio Fornoflex', 
            //                 valor: 500, 
            //                 dataprevista: '2020-03-15', 
            //                 org_nome: 'FORNOFLEX', 
            //                 pessoa_nome: 'EBOROMELLO', 
            //                 count_agenda: 2,
            //                 negocio_atraso: true, 
            //                 stnegocio: 'A',
            //             },
            //             { 
            //                 codnegocio: 2, 
            //                 titulo: 'Negocio Cozilandia', 
            //                 valor: 1500, 
            //                 dataprevista: '2020-03-31', 
            //                 org_nome: 'COZILANDIA', 
            //                 pessoa_nome: 'EBOROMELLO', 
            //                 count_agenda: 2,
            //                 negocio_atraso: true, 
            //                 stnegocio: 'A',
            //             },
            //             { 
            //                 codnegocio: 2, 
            //                 titulo: 'Negocio Cozilandia', 
            //                 valor: 1500, 
            //                 dataprevista: '2020-03-31', 
            //                 org_nome: 'COZILANDIA', 
            //                 pessoa_nome: 'EBOROMELLO', 
            //                 count_agenda: 2,
            //                 negocio_atraso: true, 
            //                 stnegocio: 'P',
            //             },
            //         ]
            //     },

            //     { 
            //         codetapa: '3',
            //         descricao: 'Qualificado',
            //         totais: [],
            //         negocios: []
            //     },

            //     { 
            //         codetapa: '5',
            //         descricao: 'Alinhado',
            //         totais: [],
            //         negocios: []
            //     },

            //     { 
            //         codetapa: '3',
            //         descricao: 'Proposta Feita',
            //         totais: [],
            //         negocios: []
            //     },

            // ]


-->

<template>

<!-- <div class="" style="overflow-x: auto;">
    <div class="pipeline" :class="cols" style="display: flex; height: auto; width: 2500px"> -->

<div class="">
    <div class="pipeline" :class="cols" style="display: flex; height: auto;">
        <div v-if="noDeals" class="no-deals">
            <span class="lbl-no-deal" style="z-index: 1000"> Nenhum negócio encontrado </span>
        </div>

        <div class="pipeline etapa" v-for="etapa in painel" :key="etapa.codetapa">
            <div class="header">
                <span class="title-etapa w-100"> {{ etapa.descricao }} </span>
                <span v-if="etapa.totais.length > 0 && etapa.totais[0].count_negocios > 1" class="card-text text-right">{{ etapa.totais[0].count_negocios }} Negócios</span>
                <span v-if="etapa.totais.length > 0" class="card-value text-right">{{ etapa.totais[0].moeda }} {{ etapa.totais[0].valor | formatValue(2) }} </span>
            </div>

            <draggable class="list-group" v-model="etapa.negocios" v-bind="dragOptions" @change="onChange" :move="onMove" @start="isDragging=true" @end="onEnd">
                <transition-group type="transition" style="height: 100%" :name="'flip-list'" :codetapa="etapa.codetapa">

                    <!-- CARDS -->
                    <crm-card v-for="negocio in etapa.negocios" :key="negocio.codnegocio" :negocio="negocio"
                        @edit="handleEditNegocio(negocio.codnegocio)"></crm-card>

                </transition-group>
            </draggable>
        </div>
    </div>
</div>

</template>

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'
import { apiDateORDS } from '../shared/api-functions'
import draggable from "vuedraggable";
import apiCrm from '../api/api-crm.js'
import AgendaForm from '../forms/agenda-form'
import CrmCard from './crm-card'

export default {
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '',  //código do filtro selecionado
    },

    components: {
        draggable, CrmCard, AgendaForm
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    data () {
        return {
            selectedIndex: -1,

            etapasFunil: [],

            painel: [],  //objeto utilizado para apresentacao

            negocioDragging: null,
            codetapa: null,

            isDragging: false,
            delayedDragging: false,

            codnegocio_detalhePopover: null,
            negocio_detalhePopover: null,

            negociocrm: null,
            noDeals: false,

        }
    },

    computed: {
        cols: function () {
            // return 'pipeline-6col'

            if (this.etapasFunil.length == 2) {
                return 'pipeline-2col'
            } else
            if (this.etapasFunil.length == 3) {
                return 'pipeline-3col'
            } else
            if (this.etapasFunil.length == 4) {
                return 'pipeline-4col'
            } else
            if (this.etapasFunil.length == 5) {
                return 'pipeline-5col'
            } else
            if (this.etapasFunil.length >= 6) {
                return 'pipeline-6col'
            }
        },

        totalList: function () {
            return this.$store.getters.getNegocioTotais[0]
        },

        negocioList: function () {
            return this.$store.getters.getNegocioList
        },

        etapaList: function () {
            if (this.$store.getters.getConfigCrm.etapas)
              return this.$store.getters.getConfigCrm.etapas
            else
              return []
        },

        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        // organizacao: function () {
        //     if (this.negociocrm && this.negociocrm.organizacao.length > 0)
        //       return this.negociocrm.organizacao[0]
        //     else 
        //       return null
        // },

        // pessoa: function () {
        //     if (this.negociocrm && this.negociocrm.pessoa.length > 0)
        //       return this.negociocrm.pessoa[0]
        //     else 
        //       return null
        // },

        // paramsAgenda: function () {
        //     return { negocio: this.negociocrm, organizacao: this.organizacao, pessoa: this.pessoa }        
        // },

    },

    watch: {
        startDate: function (value) {
            this.loadData()
        },

        funil: function (value) {
            //se o filtro de funil for alterado
            this.loadData()
        },

        usuario: function (value) {
            //se o filtro de usuario for alterado
            this.loadData()
        },

        equipe: function (value) {
            //se o filtro de equipe for alterado
            this.loadData()
        },

        filtro: function (value) {
            //se o filtro for alterado
            this.loadData()
        },
    },

    methods: {
        handleEditNegocio (codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio)
        },

        async loadData () {
            this.etapasFunil = this.funil.etapas

            let query = ''

            if (this.filtro) {
              if (query)
                query = query + '&'
              query = query + 'filtro=' + this.filtro
            }

            if (this.usuario) {
              if (query)
                query = query + '&'
              query = query + 'codusuario=' + this.usuario
            }

            if (this.equipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.equipe
            }

            if (this.startDate) {
              if (query)
                query = query + '&'
              query = query + 'data=' + apiDateORDS(this.startDate)
            }

            this.painel = []

            await this.$store.dispatch('loadPainelCrm', { codfunil: this.funil.codfunil, tipo: 'etapas', query: query })
            await this.$store.dispatch('loadPainelCrm', { codfunil: this.funil.codfunil, tipo: 'total', query: query })

            let obj = {}
            let totais = []
            let negocios = []

            /*
            MONTA O OBJETO "painel" PARA APRESENTACAO

            painel: [
                { 
                    codetapa: '',
                    descricao: '',
                    totais: [
                        { moeda: '', total: 0 },
                    ],
                    negocios: [
                        {},
                    ]
                }
            ]

            */
            for (var x = 0; x < this.etapasFunil.length; x++) {
                obj = {...this.etapasFunil[x]}
                obj.totais = []
                obj.negocios = []
                
                if (this.totalList) {
                    totais = this.totalList.por_etapas.filter((obj) => { return obj.codetapa == this.etapasFunil[x].codetapa })
                    for (var y = 0; y < totais.length; y++) {
                        obj.totais = totais[y].moedas
                    }
                }
                if (obj.totais.length == 0) {
                    obj.totais.push({ count_negocios: 0, moeda: null, valor: 0 })
                }

                negocios = this.negocioList.filter((obj) => { return obj.codetapa == this.etapasFunil[x].codetapa })
                for (var y = 0; y < negocios.length; y++) {
                    obj.negocios.push(negocios[y])
                }

                this.painel.push(obj)
            }

            this.noDeals = this.negocioList.length == 0

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

        },

        gravaEtapa () {
            if (!this.negocioDragging)
              return
            let data = {
                    codnegocio: this.negocioDragging.codnegocio, 
                    codetapa: this.codetapa 
                }
            this.apiNegocio(data, data.codnegocio, this.callBackPost)
        },

        callBackPost (negocio) {
            //EFETUA A ATUALIZACAO DOS TOTAIS DAS ETAPAS AO MOVIMENTAR O NEGOCIO

            let etapaAnterior = this.negocioDragging.codetapa
            let etapaAtual = negocio.codetapa
            this.negocioDragging = negocio

            //atualiza os totais no painel
            for (var x = 0; x < this.painel.length; x++) {
                if (this.painel[x].codetapa == etapaAnterior) {
                    this.painel[x].totais[0].valor = this.painel[x].totais[0].valor - negocio.valor
                    this.painel[x].totais[0].count_negocios = this.painel[x].totais[0].count_negocios - 1
                }
                if (this.painel[x].codetapa == etapaAtual) {
                    this.painel[x].totais[0].valor = this.painel[x].totais[0].valor + negocio.valor
                    this.painel[x].totais[0].count_negocios = this.painel[x].totais[0].count_negocios + 1

                    for (var y = 0; y < this.painel[x].negocios.length; y++) {
                        if (this.painel[x].negocios[y].codnegocio == negocio.codnegocio)
                            this.painel[x].negocios[y].codetapa = negocio.codetapa
                            this.painel[x].negocios[y].dias_estagnado = 0
                    }
                }
            }

            this.negocioDragging = null

        },

        // DRAG EVENTS
        onChange(evt) {
            //console.log(evt)
        },

        onMove({ relatedContext, draggedContext }) {
            this.negocioDragging = draggedContext.element

            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            );
        },

        onEnd(obj) {
            this.isDragging = false
            // console.log(obj.from.attributes)
            // console.log(obj.to.attributes)

            this.codetapa = obj.to.attributes[0].value
            // console.log('codetapa: ' + this.codetapa)
            // console.log(this.negocioDragging)
            this.gravaEtapa()
        }

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    created () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.loadData()
    }
  
}
</script>

<style>

</style>






// WEBPACK FOOTER //
// src/forms-crm/crm-painel-etapa.vue